import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilSequence from "@/utils/UtilSequence.mjs";

export default {

    async criarContasAPagar(contasAPagarValores = []){

        let contasAPagar = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //===================== Criar Contas a Pagar =======================//
            //==================================================================//

            contasAPagar.data = await UtilSequence.each({
                list: contasAPagarValores,
                callback: async (contasAPagarValor)=>{

                    let contaAPagar = await ERP.postOne(Schema.CONTAS_A_PAGAR, contasAPagarValor);
                    if(contaAPagar.status != 200){
                        throw contaAPagar;
                    }

                    return contaAPagar.data;

                }
            });

        }catch(e){

            console.log(e);
            contasAPagar.status = 500;
            return contasAPagar;

        }

        return contasAPagar;

    },

    async liberarContasAPagar(contasAPagarValores = []){

        let contasAPagar;

        try{

            //==================================================================//
            //==================== Liberar Contas a Pagar ======================//
            //==================================================================//

            contasAPagarValores = contasAPagarValores.map((contasAPagar)=>{

                return{
                    ...contasAPagar,
                    status: "Aguardando Aprovação",
                    aprovador: null,
                    reprovador: null,
                    reprovadorJustificativa: "",
                }

            });

            contasAPagar = await ERP.patchMany(Schema.CONTAS_A_PAGAR, contasAPagarValores);
            if(contasAPagar.status != 200){
                throw contasAPagar;
            }

            console.log(contasAPagar);

        }catch(e){

            console.log(e);
            return contasAPagar;

        }

        return contasAPagar;

    },

    async reprovarContasAPagar(contasAPagarValores = []){

        let contasAPagar;

        try{

            //==================================================================//
            //=================== Reprovar Contas a Pagar ======================//
            //==================================================================//

            contasAPagarValores = contasAPagarValores.map((contasAPagar)=>{

                return{
                    ...contasAPagar,
                    status: "Prevista",
                    aprovador: null,
                }

            });

            contasAPagar = await ERP.patchMany(Schema.CONTAS_A_PAGAR, contasAPagarValores);
            if(contasAPagar.status != 200){
                throw contasAPagar;
            }

            console.log(contasAPagar);

        }catch(e){

            console.log(e);
            return contasAPagar;

        }

        return contasAPagar;

    },

    async aprovarContasAPagar(contasAPagarValores = []){

        let contasAPagar;

        try{

            //==================================================================//
            //==================== Aprovar Contas a Pagar ======================//
            //==================================================================//

            contasAPagarValores = contasAPagarValores.map((contasAPagar)=>{

                return{
                    ...contasAPagar,
                    status: "Liberada",
                    reprovador: null,
                    reprovadorJustificativa: "",
                }

            });

            contasAPagar = await ERP.patchMany(Schema.CONTAS_A_PAGAR, contasAPagarValores);
            if(contasAPagar.status != 200){
                throw contasAPagar;
            }

            console.log(contasAPagar);

        }catch(e){

            console.log(e);
            return contasAPagar;

        }

        return contasAPagar;

    },

}